import * as Reflux from "reflux";
export const TrackingActions = {
	trackCheckoutStep: Reflux.createAction(["trackCheckoutStep"]),
	trackCheckoutSkipStep: Reflux.createAction(["trackCheckoutSkipStep"]),
	trackCheckoutNavigation: Reflux.createAction(["trackCheckoutNavigation"]),
	trackCheckoutCreated: Reflux.createAction(["trackCheckoutCreated"]),
	onPaymentPreauthorization: Reflux.createAction(["onPaymentPreauthorization"]),
	trackSubmitSuccess: Reflux.createAction(["trackSubmitSuccess"]),
	trackCreditCheck: Reflux.createAction(["trackCreditCheck"]),
	trackMovWarningShown: Reflux.createAction(["trackMovWarningShown"]),
	trackCartRestocked: Reflux.createAction(["trackCartRestocked"]),
	trackSavedCartLoaded: Reflux.createAction(["trackSavedCartLoaded"]),
	trackNotificationShown: Reflux.createAction(["trackNotificationShown"]),
	trackUnavailablePaymentShown: Reflux.createAction(["trackUnavailablePaymentShown"]),
	trackUnavailableMetroCreditShown: Reflux.createAction(["trackUnavailableMetroCreditShown"]),
	trackUnavailablePaymentDialogShown: Reflux.createAction(["trackUnavailablePaymentDialogShown"]),
	trackQuickEntrySearch: Reflux.createAction(["trackQuickEntrySearch"]),
	trackQuickEntryResults: Reflux.createAction(["trackQuickEntryResults"]),
	trackGuerillaFeature: Reflux.createAction(["trackGuerillaFeature"]),
	trackComponent: Reflux.createAction(["trackComponent"]),
	trackAbandonedCartEmailClick: Reflux.createAction(["trackAbandonedCartEmailClick"]),
	trackAbandonedCartEmailCartMismatch: Reflux.createAction(["trackAbandonedCartEmailCartMismatch"]),
};
